require('../styles.css');
"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/icons/monochrome/IconPlus.tsx
var IconPlus_exports = {};
__export(IconPlus_exports, {
  default: () => IconPlus_default
});
module.exports = __toCommonJS(IconPlus_exports);

// src/assets/monochrome/plus.svg
var import_jsx_runtime = require("react/jsx-runtime");
var SvgPlus = (props) => /* @__PURE__ */ (0, import_jsx_runtime.jsx)("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props, children: /* @__PURE__ */ (0, import_jsx_runtime.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0013 2.125C10.4845 2.125 10.8763 2.51675 10.8763 3V9.12529H17.125C17.6082 9.12529 18 9.51704 18 10.0003C18 10.4835 17.6082 10.8753 17.125 10.8753H10.8763V17C10.8763 17.4832 10.4845 17.875 10.0013 17.875C9.51801 17.875 9.12626 17.4832 9.12626 17V10.8753H3C2.51675 10.8753 2.125 10.4835 2.125 10.0003C2.125 9.51704 2.51675 9.12529 3 9.12529H9.12626V3C9.12626 2.51675 9.51801 2.125 10.0013 2.125Z", fill: "#818898" }) });
var plus_default = SvgPlus;

// src/Wrappers/helpers.ts
var getIconBaseCssVariables = ({
  size,
  rotate,
  transitionDuration
}) => {
  return {
    "--icon-size": size ? `${size}px` : "100%",
    "--icon-rotate": rotate ? `${rotate}deg` : "0deg",
    // Browser cannot handle multiple transitions on the same property if another variable (e.g. --transition-duration)
    // is defined on another element.
    "--icon-transition-fill": transitionDuration ? `fill ${transitionDuration} ease` : "none",
    "--icon-transition-transform": transitionDuration ? `transform ${transitionDuration} ease` : "none"
  };
};
var getIconColoringCssVariables = ({
  state,
  color,
  activeColor
}) => {
  return {
    "--icon-color": state === "active" ? activeColor : color,
    "--icon-active-color": state === "disabled" || !activeColor ? color : activeColor
  };
};

// src/Wrappers/IconWrapper.tsx
var import_jsx_runtime2 = require("react/jsx-runtime");
var getWrapperStyles = (props) => ({
  ...getIconBaseCssVariables(props),
  ...getIconColoringCssVariables(props)
});
var IconWrapper = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    "div",
    {
      className: "ui-icon-size-wrapper ui-icon-coloring-wrapper",
      style: getWrapperStyles(props),
      children: props.children
    }
  );
};

// src/icons/monochrome/IconPlus.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var IconPlus = (props) => {
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(IconWrapper, { ...props, children: /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(plus_default, {}) });
};
IconPlus.displayName = "IconPlus";
var IconPlus_default = IconPlus;
